var window=global;var $CLJS=require("./cljs_env.js");
'use strict';$CLJS.QH=require("moment");module.exports=$CLJS.QH;